<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <el-select v-model="filterParams.grade_id" placeholder="请选择评级公司" @change="loadData(1)"
                    class="header-input">
                    <el-option :label="'不限评级公司'" :value="''"></el-option>
                    <el-option v-for="item in grades" :key="item.gradeId" :label="item.gradeName"
                        :value="item.gradeId"></el-option>
                </el-select>
                <el-select v-model="filterParams.category_id" placeholder="请选择钱币朝代" @change="loadData(1)" class="header-input">
                    <el-option :label="'不限钱币朝代'" :value="''"></el-option>
                    <el-option :label="group.categoryName" :value="group.categoryId" v-for="group in categorys"></el-option>
                </el-select>
                <el-input v-model="filterParams.product_name" placeholder="请输入钱币名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_appraisal" placeholder="请输入评级编码" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.prize_min" placeholder="请输入价格下限" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.prize_max" placeholder="请输入价格上限" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-date-picker v-model="filterParams.date_start" placeholder="请输入起始时间" class="header-input" type="date" value-format="yyyy-MM-dd" @change="loadData(1)" style="width: 160px;"></el-date-picker>
                <el-date-picker v-model="filterParams.date_end" placeholder="请输入终止时间" class="header-input" type="date" value-format="yyyy-MM-dd" @change="loadData(1)" style="width: 160px;"></el-date-picker>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 0px;">
            <product-prize-component v-for="product in records" :product="product"></product-prize-component>
        </div>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getLogTypeName(scheduleForm.logType)" :visible.sync="statusLayer" width="30%"
            :close-on-click-modal="false">
            <el-form ref="form" label-width="90px">
                <el-form-item label="代卖人" v-if="(manager || distribute) && scheduleForm.logType > 1">
                    <el-select v-model="scheduleForm.salerId" placeholder="请选择代卖人" style="width: 100%;">
                        <el-option v-for="item in saleAdmins" :key="item.adminId" :label="item.adminName"
                            :value="item.adminId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评级编码" v-if="(manager || distribute) && scheduleForm.logType == 1">
                    <el-input v-model="scheduleForm.productCode"></el-input>
                </el-form-item>
                <el-form-item label="操作备注">
                    <el-input v-model="scheduleForm.memo"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateStatusClose()">取 消</el-button>
                <el-button type="primary" @click="updateStatusConfirm()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="操作日志" :visible.sync="logLayer" width="30%" :close-on-click-modal="false">
            <div class="block">
                <el-timeline>
                    <el-timeline-item v-for="(log, index) in logs" :key="index" type="primary" color="#0bbd87"
                        size="large" :timestamp="convertToDate(log.logDate)">
                        {{ getLogTypeName(log.logType) }}
                        <span v-if="log.salerId"> / 代卖人：{{ log.salerName }}</span>
                        <span v-if="log.adminId"> / 操作人：{{ log.adminName }}</span>
                        <span v-if="log.logMemo" style="color: #FF0000; font-weight: bold;"> / 备注：{{ log.logMemo
                            }}</span>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="logLayer = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"
import scheduleMixin from "@/mixins/schedule-mixin.js"
import productPrizeComponent from "@/components/ProductPrizeComponent.vue"

import { API, doGet, doPost } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin, enumMixin, scheduleMixin],
    data: function () {
        return {
            grades: [],
            categorys: []
        }
    },
    methods: {
        reloadData: async function () {
            this.grades = await doGet(API.ALL.GRADE);
            this.categorys = await doGet(API.TREE.CATEGORY);
            this.$forceUpdate();
        },
    },
    created: function () {
        this.size = 20;
        this.tag = "PRIZE";
        this.filterParams = {
            grade_id: "",
            category_id: "",
            product_appraisal: "",
            product_name: "",
            date_start: "",
            date_end: "",
            prize_min: "",
            prize_max: "",
        };
    },
    components: {
        "product-prize-component": productPrizeComponent
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>